module.exports = __webpack_public_path__ + "images/bygg-verktyg.a65ae978.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/EbaySweden.TouchWeb/static/images/category-carousel/bygg-verktyg.jpg
// module id = e5366b8d
// module chunks = 10 37